<ion-header [translucent]="true">
  <ion-toolbar class="app-header-toolbar">
    <ion-buttons slot="start">
      <ion-menu-button class="app-menu-button" aria-label="Open menu">
        <img src="assets/icon/noisy-radio-icon-192.png" width="64" height="64" alt="" class="menu-app-icon" />
      </ion-menu-button>
    </ion-buttons>
    <ion-title>{{ title }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-header collapse="condense">
    <ion-toolbar>
      <ion-title size="large">{{ title }}</ion-title>
    </ion-toolbar>
  </ion-header>

  <div class="legal-page">
    <div class="legal-page__content" [innerHTML]="content$ | async"></div>

    <ion-card *ngIf="showCookiePreferences">
      <ion-card-header>
        <ion-card-title>Cookie Preferences</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <p>Update your consent choices at any time.</p>
        <ion-button size="small" (click)="openCookiePreferences()">Open Cookie Preferences</ion-button>
      </ion-card-content>
    </ion-card>

    <ion-card *ngIf="showOperatorInfo">
      <ion-card-header>
        <ion-card-title>Operator Contact</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <p><strong>Company:</strong> {{ config.companyName || config.siteName }}</p>
        <p><strong>Address:</strong> {{ config.businessAddress || 'Not provided' }}</p>
        <p>
          <strong>Support:</strong>
          <span *ngIf="config.supportEmail; else feedbackSupport">{{ config.supportEmail }}</span>
          <ng-template #feedbackSupport>
            <a routerLink="/feedback">Feedback page</a>
          </ng-template>
        </p>
        <p *ngIf="config.supportPhone"><strong>Phone:</strong> {{ config.supportPhone }}</p>
      </ion-card-content>
    </ion-card>

    <ion-card *ngIf="showSoundCredits" id="sound-credits">
      <ion-card-header>
        <ion-card-title>Sound Credits</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <ng-container *ngIf="manifest$ | async as manifest; else noCredits">
          <div *ngIf="manifest?.entries?.length; else noCredits">
            <ion-list>
              <ion-item *ngFor="let entry of manifest.entries">
                <ion-label>
                  <h3>{{ entry.filename }}</h3>
                  <p>{{ entry.attribution }}</p>
                  <p>Source: {{ entry.source }}</p>
                  <p>License: {{ entry.license }}</p>
                  <p>Redistribution: {{ entry.allowed_redistribution ? 'Allowed' : 'Not allowed' }}</p>
                </ion-label>
              </ion-item>
            </ion-list>
          </div>
        </ng-container>
        <ng-template #noCredits>
          <p>No sound credits are configured yet.</p>
        </ng-template>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
